/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Box } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ResultTableHead } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { getCurrentDate } from '../../../../SharedModules/utilities/utilities';
import {
  getDisputeAmount,
  getResultManufacturerSummary,
} from '../Store/actions';

export default function DispManufacturerSummary() {
  const dispatch = useDispatch();
  const {
    displayObj: {
      searchResult = {},
      earliestQtr,
      dramsInvoice,
      threshold,
      selectedQuarterOption,
      rprtBalThresholdValue,
      selectedRow,
      rebateProgramValue,
      disputeAmountForQuarter = [],
    },
    isLoading,
  } = useSelector((state) => state?.sharedState?.ManufacturerSummaryReducer);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const currentDate = getCurrentDate('MM/DD/YYYY');

  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    // dispatch(
    //   getResultManufacturerSummary({
    //     mfgId: selectedRow[0]?.mfgId,
    //     rpc: rebateProgramValue,
    //   })
    // );
    // dispatch(
    //   getDisputeAmount({
    //     mfgId: selectedRow[0]?.mfgId,
    //     rpc: rebateProgramValue,
    //   })
    // );
  }, []);
  React.useEffect(() => {
    if (
      Object.keys(searchResult).length > 0 &&
      disputeAmountForQuarter.length > 0
    ) {
      let rows = [];
      const {
        manufactureSummaryReportFourthList: fourthList = [],
        manufactureSummaryReportMainList: mainList = [],
        manufactureSummaryReportSecondList: secondList = [],
        manufactureSummaryReportThirdList: thirdList = [],
        manufactureSummaryDisputeAmountForQuarterVOList:
          fifthList = disputeAmountForQuarter,
      } = searchResult;
      const secondListQtrObj = secondList?.reduce((acc, item) => {
        acc[item.qtr] = item;
        return acc;
      }, {});
      const thirdListQtrObj = thirdList?.reduce((acc, item) => {
        acc[item.targetQtr] = item;
        return acc;
      }, {});
      const fourthListQtrObj = fourthList?.reduce((acc, item) => {
        acc[item.invRecQtr] = item;
        return acc;
      }, {});
      const fifthListOtrObj = fifthList?.reduce((acc, item) => {
        acc[item.qtr] = item;
        return acc;
      }, {});

      rows = mainList?.map((item) => {
        return {
          ...item,
          ccAmountOwed: secondListQtrObj[item.qtr]?.ccAmountOwed
            ? parseFloat(secondListQtrObj[item.qtr]?.ccAmountOwed?.toFixed(2))
            : '0.00',
          cccalcCharge: secondListQtrObj[item.qtr]?.cccalcCharge
            ? parseFloat(secondListQtrObj[item.qtr]?.cccalcCharge?.toFixed(2))
            : '0.00',
          ccUnitChange: thirdListQtrObj[item.qtr]?.ccUnitChange
            ? parseFloat(thirdListQtrObj[item.qtr]?.ccUnitChange)?.toFixed(4)
            : '0.0000',
          ccInterest: fourthListQtrObj[item.qtr]?.ccInterest
            ? parseFloat(fourthListQtrObj[item.qtr]?.ccInterest?.toFixed(2))
            : '0.00',
          ccPrincipal: fourthListQtrObj[item.qtr]?.ccPrincipal
            ? parseFloat(fourthListQtrObj[item.qtr]?.ccPrincipal?.toFixed(2))
            : '0.00',
          disputedAmount: fifthListOtrObj[item.qtr]?.disputedAmount
            ? parseFloat(fifthListOtrObj[item.qtr]?.disputedAmount?.toFixed(2))
            : '0.00',
        };
      });
      rows = rows?.map((item) => {
        const adjustments =
          item.cccalcCharge - item.totCurrQtrAmt === 0
            ? '0.00'
            : parseFloat((item.cccalcCharge - item.totCurrQtrAmt).toFixed(2));
        return {
          ...item,
          adjustments,
          totCurrQtrAmt: item.totCurrQtrAmt ? item.totCurrQtrAmt : '0.00',
        };
      });

      if (selectedQuarterOption === 'DRAMS Invoice Start Quarter') {
        const dramsYear = parseInt(dramsInvoice.substring(2, 6));
        const dramsQuarter = dramsInvoice.substring(0, 2);
        rows = rows?.filter((item) => {
          const year = parseInt(item.qtr.substring(2, 6));
          const quarter = item.qtr.substring(0, 2);

          return (
            year > dramsYear || (year === dramsYear && quarter >= dramsQuarter)
          );
        });
      }
      if (selectedQuarterOption === 'Earliest Quarter for Drug Details') {
        const earliestYear = parseInt(earliestQtr.substring(2, 6));
        const earliestQuarter = earliestQtr.substring(0, 2);
        rows = rows?.filter((item) => {
          const year = parseInt(item.qtr.substring(2, 6));
          const quarter = item.qtr.substring(0, 2);

          return (
            year > earliestYear ||
            (year === earliestYear && quarter >= earliestQuarter)
          );
        });
      }
      if (rprtBalThresholdValue) {
        rows = rows?.filter(
          (item) => Math.abs(item.ccAmountOwed) >= Math.abs(threshold)
        );
      }

      setRows(rows);
    } else {
      setRows([]);
    }
  }, [searchResult, disputeAmountForQuarter]);
  const frameworkComponents = {
    ToolTipRender: (cellInfo) => {
      const name = cellInfo?.data?.invoiceStatusCd;
      if (name && name.length > 15) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rows;

    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    if (property === 'ccUnitChange') {
      return data ? data?.toFixed(4) : '0.0000';
    }
    return data ? parseFloat(data.toFixed(2)) : '0.00';
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        totCurrQtrAmt: sum('totCurrQtrAmt'),
        ccAmountOwed: sum('ccAmountOwed'),
        ccInterest: sum('ccInterest'),
        ccPrincipal: sum('ccPrincipal'),
        adjustments: sum('adjustments'),
        disputedAmount: sum('disputedAmount'),
        ccUnitChange: sum('ccUnitChange'),
        qtr: 'Total:',
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  // Below variable are used for PDF header

  const firstInfo = '';
  const secondInfo = `Manufacturer Id: ${selectedRow[0]?.mfgId}`;
  const thirdInfo = rebateProgramValue;
  const fourthInfo = `Manufacturer Name: ${selectedRow[0]?.mfgName}`;
  const fifthInfo = rprtBalThresholdValue
    ? `Balance Due Threshold: $${threshold}`
    : '';
  const sixthInfo = `Report Quarter Option: ${selectedQuarterOption}`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <div className="tab-body">
          <CustomSeparator
            parent1="Detail Reports"
            parent2="Display Manufacturer Summary"
          />
          <div className="row mb-2">
            <Box className="alone-pagination mb-5 mt-3 mr-4">
              <h6>Date Printed: {currentDate}</h6>
            </Box>
          </div>
          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-3">
              <div className="col-6">
                <TextField
                  label="Manufacturer ID: "
                  id="Manufacturer ID"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={selectedRow[0]?.mfgId}
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="Manufacturer Name:"
                  id="Manufacturer Name"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={selectedRow[0]?.mfgName}
                  name="dateRange"
                  disabled
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <TextField
                  label="Report Quarter Option:"
                  id="Report Quarter Option"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={selectedQuarterOption}
                  disabled
                />
              </div>
              {rprtBalThresholdValue && (
                <div className="col-6">
                  <TextField
                    label="Balance Due Threshold:"
                    id="Balance Due Threshold"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={`$ ${threshold}`}
                    name="dateRange"
                    disabled
                  />
                </div>
              )}
            </div>
            <div className="row ">
              <div className="col-6">
                <TextField
                  label="Rebate Program:"
                  id="Rebate Program:"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={rebateProgramValue}
                  name="dateRange"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <TableGrid
        //   onSelectionChanged={onSelectionChanged}
        rowData={rows}
        helpMessage
        // gridHeight={viewPortHeight_355}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        columnDefs={ResultTableHead}
        rowSelection="single"
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        reportName="Manufacturer Summary Report"
        fileName="ManufacturerSummary"
        enterMovesDown
        isScrollOn
        defaultCol={{
          wrapHeaderText: true,
        }}
        suppressCellFocus
        singleClickEdit
        exportFile
        hideColumnsInPdf
        pinnedBottomRowData={pinnedBottomRowData}
        info={{
          firstInfo,
          secondInfo,
          thirdInfo,
          fourthInfo,
          fifthInfo,
          sixthInfo,
        }}
        frameworkComponents={frameworkComponents}
        onFilterData={onFilterChanged}
        getFilterApply={getFilterApply}
      />
    </div>
  );
}
